var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-select',{attrs:{"items":_vm.items,"outlined":_vm.outlined,"hide-details":_vm.hideDetails,"item-text":"name","item-value":"id","label":"Email Type"},on:{"change":_vm.onChange},model:{value:(_vm.selectedEmailType),callback:function ($$v) {_vm.selectedEmailType=$$v},expression:"selectedEmailType"}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4122613f","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/gt/shared/EmailTypesListSelect.vue
// module id = null
// module chunks = 